export const founders = [
    {
        name: "Asif Hakeem",
        role: "Founder",
        education: "B.Tech (Information Technology) | LL.B. | International Trade Entrepreneur",
        image: "/img/asif.jpeg",
        story:
            "Asif Hakeem is a tech-driven entrepreneur with a multidisciplinary foundation spanning Information Technology, Law, and International Trade. His career began in the IT industry, where he worked across software development, IT consulting, digital technologies, and digital transformation, developing a strong understanding of scalable systems and business technology.",
        bio:
            "Complementing his technical expertise, Asif pursued a Bachelor of Laws (LL.B.) with a focused interest in Cyber Law, Intellectual Property Rights (IPR), and commercial legal frameworks, strengthening his ability to navigate the legal, compliance, and risk management aspects of modern global business. As Co-Founder of Exportfy.world, he combines technology, legal awareness, and international market expertise to build trusted supply chains between Indian manufacturers and global buyers. His vision is to leverage digital innovation, regulatory compliance, and strategic sourcing to make cross-border trade more transparent, secure, and efficient. He believes that sustainable global business is built on three pillars: Technology, Trust, and Compliance.",
    },
    {
        name: "Nitin Yadav",
        role: "Co-Founder | Global Business & International Trade",
        education: "Bachelor’s Education in Singapore | Master’s in International Business — Newcastle University, London",
        image: "/img/nitin.jpeg",
        story:
            "Nitin Yadav is an international business professional with a global outlook and expertise in cross-border trade. Having completed his Bachelor’s education in Singapore and a Master’s in International Business from Newcastle University, London, he combines international exposure with a deep understanding of global commerce.",
        bio:
            "As Co-Founder of Exportfy.world, Nitin is responsible for international market development, global buyer acquisition, strategic partnerships, and overseas business expansion. His focus is on building long-term relationships with importers, distributors, and institutional buyers while strengthening Exportfy’s position as a trusted global sourcing and merchant export platform. He believes that India’s manufacturing strength, combined with technology and transparent trade practices, can create lasting value for businesses worldwide.",
    },
];

export const teamMembers = [
    {
        name: "Rhea Menon",
        role: "Head of Sourcing",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600",
    },
    {
        name: "Karan Verma",
        role: "Export Documentation Lead",
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600",
    },
    {
        name: "Aisha Rahman",
        role: "GCC Business Development",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600",
    },
    {
        name: "Vikram Singh",
        role: "Head of QA & Factory Audits",
        image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600",
    },
    {
        name: "Meera Iyer",
        role: "Buyer Success Manager",
        image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=600",
    },
    {
        name: "Daniel Okafor",
        role: "Africa Market Lead",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600",
    },
];
